import styled from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../styled components/Typography';

export default styled(Body).attrs({
  $color: 'gray dark'
})(() => [tw`text-center p-16`]);
